import { map, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { Input, Directive, forwardRef } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[validateUniqueEmail][formControlName],[validateUniqueEmail][formControl],[validateUniqueEmail][ngModel]',
    providers: [
        { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => UniqueEmailValidator), multi: true }
    ]
})
export class UniqueEmailValidator implements AsyncValidator {
    @Input() userId;
    @Input() hostname;

    constructor(private userService: UserService) {}
    //TODO pattern pattern="[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})"
                        
    validate(control: AbstractControl): Observable<{ [key: string]: any }> {
        return this.userService.getUserByEmail(control.value, this.hostname)
        .pipe(
            debounceTime(250),
            distinctUntilChanged(),
            map(user => user.id === this.userId ? undefined : { validateUniqueEmail: true })
        );
    }
}
